'use client';

import { useEffect, useState } from 'react';

export const SourceInput = (props: any) => {
  const [url, setUrl] = useState('');

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  return <input {...props} value={url} />;
};

export default SourceInput;
